<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    custom-class=""
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('icon-circle-fill')" />
          <span>切换奖励方式</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content" style="margin: 32px 0 24px 0">
        <p class="title">确认切换为{{ title }}方式？</p>
        <div class="txt">
          <span> 切换方式后续奖励将会以“{{ title }}”发放 </span>
        </div>
      </div>
      <div class="d-footer">
        <fm-button class="button" @click="confirm" type="primary" size="small"
          >确 认</fm-button
        >
        <fm-button @click="handleClose" type="info" plain size="small"
          >取 消</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'change',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '开通金额奖励',
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    confirm() {
      let num = this.title == '会员时长奖励' ? 0 : 1
      this.$emit('confirm', num)
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 400;
  font-size: 16px;
  color: #2c2c2c;
  line-height: 24px;
  margin-bottom: 12px;
}
.txt {
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #2c2c2c;
  line-height: 22px;
}
.d-footer {
  .button {
    background-color: #7e72f6;
    border-color: #7e72f6;
  }
  .button:hover {
    background-color: #9187f7;
    border-color: #9187f7;
  }
  .button:active {
    background-color: #3213d8;
    border-color: #3213d8;
  }
}
</style>
